module.exports = __webpack_public_path__ + "static/ohazurike-3c1949ef0ec3572619fd7a46862418ae.png";